const balancePayRemainingReducer = (state = 0, action) => {
	switch(action.type){
	case 'BALANCEPAYREMAINING':
		return action.payload;
	default:
		return state;
	}
}

export default balancePayRemainingReducer;